import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WEBSITE_URL } from '../../../../config/appConfig';
import i18n from '../../../../i18n';

const InvestorFooter = () => {
	const { t } = useTranslation();
	const lang = i18n.language || 'en';

	const termsUrl = `${WEBSITE_URL}${lang}/terms-of-use/`;
	const privacyUrl = `${WEBSITE_URL}${lang}/privacy-policy/`;

	return (
		<Box className="w-full mt-8 flex justify-center" style={{ backgroundColor: '#00D175', minHeight: '245px', paddingTop: '42px' }}>
			<Box className="flex flex-col items-center gap-[20px]">
				<Box className="flex gap-6">
					<a
						href={termsUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="underline"
						style={{ fontWeight: 700, fontSize: '13px', color: '#143135', lineHeight: 1 }}
					>
						{t('footer.termsAndConditions')}
					</a>
					<a
						href={privacyUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="underline"
						style={{ fontWeight: 700, fontSize: '13px', color: '#143135', lineHeight: 1 }}
					>
						{t('footer.privacyPolicy')}
					</a>
				</Box>
				<p className="m-0" style={{ fontWeight: 400, fontSize: '13px', color: '#143135', lineHeight: 1 }}>
					{t('footer.copyright', { year: new Date().getFullYear() })}
				</p>
			</Box>
		</Box>
	);
};

export default InvestorFooter;
